import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Trash2, Plus, ExternalLink, Star } from "lucide-react";
import api from "@/lib/api";

export default function AdminInterviews() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const r = await api.get("/interviews", { params: { limit: 500 } });
    setItems(r.data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const remove = async (slug) => {
    if (!confirm("Delete this interview? This cannot be undone.")) return;
    try {
      await api.delete(`/admin/interviews/${slug}`);
      toast.success("Deleted");
      load();
    } catch {
      toast.error("Failed to delete.");
    }
  };

  return (
    <div data-testid="admin-interviews">
      <div className="flex items-center justify-between mb-8">
        <div>
          <div className="eyebrow text-oc-coral mb-2">Interviews</div>
          <h1 className="font-editorial text-4xl text-oc-ink">Manage interviews</h1>
        </div>
        <Link
          to="/admin/interviews/new"
          data-testid="admin-new-interview"
          className="h-12 px-5 bg-oc-blue text-white font-ui text-xs font-bold uppercase tracking-widest flex items-center gap-2 hover:bg-oc-blue-hover"
        >
          <Plus className="w-4 h-4" /> New Interview
        </Link>
      </div>
      {loading ? (
        <div className="py-24 text-center">Loading...</div>
      ) : (
        <div className="border border-oc-hairline">
          <div className="grid grid-cols-12 gap-4 px-6 py-3 border-b border-oc-hairline eyebrow text-oc-ink-muted bg-oc-sand">
            <div className="col-span-6">Title</div>
            <div className="col-span-2">Guest</div>
            <div className="col-span-2">Industry</div>
            <div className="col-span-2 text-right">Actions</div>
          </div>
          {items.map((iv) => (
            <div key={iv.slug} className="grid grid-cols-12 gap-4 px-6 py-4 border-b border-oc-hairline last:border-0 items-center hover:bg-oc-sand/50">
              <div className="col-span-6">
                <Link to={`/admin/interviews/${iv.slug}`} className="font-ui font-semibold text-oc-ink hover:text-oc-blue">
                  {iv.title}
                </Link>
                <div className="font-ui text-xs text-oc-ink-muted mt-1 flex items-center gap-3">
                  <span>/{iv.slug}</span>
                  {iv.featured && <span className="inline-flex items-center gap-1 text-oc-coral"><Star className="w-3 h-3" /> featured</span>}
                  {iv.editors_pick && <span className="text-oc-blue">editor's pick</span>}
                </div>
              </div>
              <div className="col-span-2 font-ui text-sm">{iv.guest_name}</div>
              <div className="col-span-2 font-ui text-sm text-oc-ink-muted">{iv.industry_slug}</div>
              <div className="col-span-2 flex items-center justify-end gap-2">
                <a href={`/interviews/${iv.slug}`} target="_blank" rel="noreferrer" className="p-2 hover:bg-oc-sand" aria-label="View">
                  <ExternalLink className="w-4 h-4" />
                </a>
                <Link to={`/admin/interviews/${iv.slug}`} className="font-ui text-xs font-bold uppercase tracking-widest text-oc-blue hover:text-oc-ink">
                  Edit
                </Link>
                <button
                  data-testid={`delete-${iv.slug}`}
                  onClick={() => remove(iv.slug)}
                  className="p-2 hover:bg-oc-sand text-oc-coral"
                  aria-label="Delete"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
